export default __webpack_public_path__ + "static/media/arabe.ac1a6e61.png";